import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
// import { closest } from 'next/javascripts/modules/dom';

Component('tr-repository-import-form', {
  mixins: [eventListenerMixin],

  connected() {
    this.input = this.querySelector('#tr_repository_import_task_resource_gids');
    this.tree = this.querySelector('tr-tree');
    this.listenTo(this.tree, 'tr-tree:selectedChange', this.handleSelected.bind(this));
  },

  handleSelected(e) {
    const value = [];
    Array.prototype.forEach.call(e.detail, (item) => {
      const { gid } = item.querySelector('.repository-tree-node').dataset;
      value.push(gid);
    });
    this.input.value = value.join(',');
  },

  disconnected() {
    this.stopListening();
  },
});
